module.exports = (mcData) => {
  const data = Object.assign({}, mcData)
  return data
}
